/* eslint-disable */
//import React from 'react';
import React from 'react';
import { Router } from 'react-router-dom';

import { AuthProvider } from 'context/AuthContext';
import history from './history';
import Routes from './routes';

const MainRoutes = () => {
  return (
    <AuthProvider>
      <Router history={history}>
        <Routes />
      </Router>
    </AuthProvider>
  );
};

export default MainRoutes;
